import { BulkAudienceSection } from '../bulk/bulk-audience-section';
import { BulkStageAudienceSection } from '../bulk-stage/bulk-stage-audience-section';
import { LeadsAudienceSection } from '../leads/leads-audience-section';
import { ParticipantsAudienceSection } from '../participants/participants-audience-section';
import { StageAudienceSection } from '../stage/stage-audience-section';
import type { TStage } from '@src/shared/types/stage';
import type { TCreateReminderVariant, TBulkStageReminderConfig } from './types';

type CreateReminderAudienceSectionProps = {
  variant: TCreateReminderVariant;
  bulkStageConfig?: TBulkStageReminderConfig;
};

export function CreateReminderAudienceSection({
  variant,
  bulkStageConfig,
}: CreateReminderAudienceSectionProps) {
  switch (variant) {
    case 'leads':
      return <LeadsAudienceSection />;
    case 'participants':
      return <ParticipantsAudienceSection />;
    case 'stage':
      return <StageAudienceSection />;
    case 'bulkStage':
      return (
        <BulkStageAudienceSection
          stages={(bulkStageConfig?.stages ?? []) as TStage[]}
        />
      );
    case 'bulk':
    default:
      return <BulkAudienceSection />;
  }
}
